// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1VVER","info":"UpdateTermsInfo_info__31H7_"};